import { FC } from 'react'
import {
  CwsGrid,
  CwsGridCol,
  CwsGridRow,
  CwsTabContentItem,
  CwsTab,
  CwsTabItem,
  CwsTabContent,
  CwsH1,
} from '@components/cws'
import s from '@components/profile/ProfileView/ProfileView.module.scss'
import { useTranslate } from '@hooks/useTranslation'
import { useRouter } from 'next/router'
import { KKContentItem } from '@api/content'
import SupportList from '../SupportList/SupportList'

interface SupportViewProps {
  tab: string
  content: KKContentItem[]
}
const SupportView: FC<SupportViewProps> = ({ tab, content }) => {
  const { translate } = useTranslate()
  const { push } = useRouter()
  return (
    <CwsGrid>
      <CwsGridRow>
        <CwsGridCol col="12" lg="12" className="cws-mt-xl">
          <CwsH1>{translate('footer.help')}</CwsH1>
        </CwsGridCol>
        <CwsGridCol col="12" lg="12">
          <>
            <CwsTab activeTabNavItemId={tab ? tab : 'profile'} mode="scroll">
              <CwsTabItem label={translate('account.faq.button')} id="frequently_asked_questions" className="relative">
                <span onClick={() => push('/support/frequently_asked_questions').then()} className={s.tabItem} />
              </CwsTabItem>
              <CwsTabItem label={translate('support.terms.button')} id="terms_and_conditions" className="relative">
                <span onClick={() => push('/support/terms_and_conditions').then()} className={s.tabItem} />
              </CwsTabItem>
              <CwsTabItem label={translate('support.returns.button')} id="returns" className="relative">
                <span onClick={() => push('/support/returns').then()} className={s.tabItem} />
              </CwsTabItem>
              <CwsTabItem label={translate('support.sizes.button')} id="size_charts" className="relative">
                <span onClick={() => push('/support/size_charts').then()} className={s.tabItem} />
              </CwsTabItem>
            </CwsTab>
            <CwsTabContent>
              <CwsTabContentItem id="frequently_asked_questions">
                <SupportList content={content} modalType="contact_us" />
              </CwsTabContentItem>
              <CwsTabContentItem id="terms_and_conditions">
                <SupportList content={content} modalType="contact_us" />
              </CwsTabContentItem>
              <CwsTabContentItem id="returns">
                <SupportList content={content} modalType="item_return" />
              </CwsTabContentItem>
              <CwsTabContentItem id="size_charts">
                <SupportList content={content} modalType="contact_us" />
              </CwsTabContentItem>
            </CwsTabContent>
          </>
        </CwsGridCol>
      </CwsGridRow>
    </CwsGrid>
  )
}
export default SupportView
